import React, { Component } from "react";
import PropTypes from "prop-types";
import { Form } from "react-bootstrap";
import _ from "lodash";

class FuseForm extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Form
        onSubmit={(e) => {
          if (this.props?.onSubmit != null) {
            this.props?.onSubmit(e);
          }
          e.preventDefault();
        }}
        onChange={(e) => {
          if (this.props?.onChange != null) {
            this.props?.onChange(e);
          }
        }}
        onInvalid={(e) => {
          if (this.props?.onInvalid != null) {
            this.props?.onInvalid(e);
          }
        }}
      >
        {this.props?.children}
      </Form>
    );
  }
}

FuseForm.propTypes = {
  onSubmit: PropTypes.func,
  onChange: PropTypes.func,
  onInvalid: PropTypes.func,
};

export default FuseForm;
